<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3">
<a class="calibre1 pcalibre1 pcalibre" href="https://earlybirdbooks.com/freebook?q=58e70c41e1799d0f58a9f009" target="_blank">
<img alt="image" class="calibre2" src="images/00004.jpeg"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?5f2c8620